module.exports = __webpack_public_path__ + "static/img/bg_success.af435dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/bg_success.png
// module id = F36m
// module chunks = 1